<div
  class="vs-toaster"
  [ngClass]="'vs-toaster--'+type"
  [class.show]="showToast">
  {{ message }}
  <i *ngIf="dismissable"
    (click)="dismissToast()"
    class="material-icons">close</i>
</div>
